import React from 'react'
import { Link } from 'react-router-dom';
import { FiAlertTriangle, FiShield } from "react-icons/fi";
import { Helmet } from 'react-helmet';
import utils from '../utils';

function PageNotFound() {
    const url = window.location.href

    return (
        <div>
            <Helmet>
                <title>Page Not Found - {utils.siteName}</title>
                <link rel="canonical" href={url} />
                <meta
                    property="description"
                    content="The requested page could not be found." />

            </Helmet>
          
            <main className=" flex flex-col items-center justify-center relative bg-base-100 px-6 overflow-hidden p-12">
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute left-1/4 top-0 bottom-0 w-px bg-zinc-800/20"></div>
                    <div className="absolute right-1/4 top-0 bottom-0 w-px bg-zinc-800/20"></div>
                    <div className="absolute top-1/3 left-0 right-0 h-px bg-zinc-800/20"></div>
                    <div className="absolute bottom-1/3 left-0 right-0 h-px bg-zinc-800/20"></div>
                </div>
                <div className="relative text-center max-w-2xl mx-auto flex flex-col items-center">

                    <div className="mb-6 p-4 rounded-full bg-base-200/50 border border-zinc-200 inline-block">
                        <FiAlertTriangle className="w-12 h-12 text-primary" />
                    </div>

                    <h1
                        className="glitch text-8xl md:text-9xl font-bold tracking-tighter text-base-content leading-none select-none"
                        data-text="404"
                    >
                        404
                    </h1>

                    <div className="space-y-4 mt-6">
                        <h2 className="text-2xl md:text-3xl font-semibold text-base-content">
                            Perimeter Boundary Reached
                        </h2>
                        <p className="text-zinc-600 max-w-md mx-auto leading-relaxed">
                            The requested asset is outside our secure domain. Our systems have logged this anomaly for review.
                        </p>
                    </div>

                    <div className="mt-10 flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
                        <Link
                            to="/"
                            className="inline-flex items-center justify-center gap-2 bg-primary text-primary-content px-8 py-3 text-xs font-bold uppercase tracking-widest rounded active:scale-95 transition-all hover:brightness-110"
                        >
                            <FiShield className="w-4 h-4" />
                            Return to Base
                        </Link>
                        <Link
                            to="/contact"
                            className="inline-flex items-center justify-center gap-2 border border-zinc-700 text-base-content px-8 py-3 text-xs font-bold uppercase tracking-widest rounded active:scale-95 transition-all hover:bg-zinc-800 hover:border-zinc-600"
                        >
                            Report Incident
                        </Link>
                    </div>
                    <div className="mt-16 pt-6 border-t border-zinc-200/50 w-full max-w-xs">
                        <div className="flex justify-between items-center font-mono text-[10px] uppercase tracking-widest text-zinc-600">
                            <span>Code: ERR_SEC_OUT_OF_BOUNDS</span>
                            <span className="flex items-center gap-1">
                                <span className="w-1.5 h-1.5 rounded-full bg-red-500/50"></span>
                                Logged
                            </span>
                        </div>
                    </div>

                </div>
            </main>
        </div>
    )
}

export default PageNotFound